import { render } from "./ImageHome.vue?vue&type=template&id=4a4d3ac7"
import script from "./ImageHome.vue?vue&type=script&lang=js"
export * from "./ImageHome.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__